import { IParameterizable } from './page-service/parameterizable.model';
import { IQueryParams } from './page-service/query-params.model';

export interface IFilterValue {
    id: string;
    name: string;
    active: boolean;
}

export interface IFilter {
    id: string;
    name: string;
    activeCount: number;
    values: IFilterValue[];
}

export class Filters implements IParameterizable {
    items: IFilter[] = [];

    constructor(items: IFilter[]) {
        this.items = items;
    }

    isEmpty(): boolean {
        return this.items.length === 0;
    }

    activeCount(): number {
        return this.items.flatMap((x: IFilter) => x.values.filter((x: IFilterValue) => x.active))
            .length;
    }

    generateParams(): IQueryParams {
        const active = this.items.filter((x: IFilter) => {
            return x.values.filter((y: IFilterValue) => y.active).length;
        });

        const params = active.flatMap((x: IFilter) =>
            x.values
                .filter((y: IFilterValue) => y.active)
                .map((y: IFilterValue) => ({ id: x.id, value: y.id }))
        );

        return {
            queryString: 'filters',
            params: params.length ? params : [],
        };
    }
}
